import { useState } from 'react';
import type { JSX } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Field, Panel } from '../components/ui.js';

/** Dočasné uvolnění „schvalovatel ≠ tvůrce“ (D-307). Jen admin, jen Vývoj a Zkouška. */
export function OwnApprovalPanel({ canChange }: { canChange: boolean }): JSX.Element {
  const client = useQueryClient();
  const state = useQuery({
    queryKey: ['own-approval'],
    queryFn: () =>
      api.get<{ enabled: boolean; stored: boolean; production: boolean }>(
        '/api/settings/own-approval',
      ),
  });
  const [text, setText] = useState('');
  const [note, setNote] = useState<string | null>(null);
  const change = useMutation({
    mutationFn: (enabled: boolean) =>
      api.post('/api/settings/own-approval', { enabled, confirmation: text }),
    onSuccess: () => {
      setText('');
      setNote(null);
      void client.invalidateQueries({ queryKey: ['own-approval'] });
    },
    onError: (err: Error) => setNote(err.message),
  });
  const on = state.data?.enabled === true;
  return (
    <Panel title="Povolit schválení vlastním účtem">
      <p className="note">
        Dočasné uvolnění pravidla „schvalovatel není tvůrce“. Smí se zapnout jen ve Vývoji a
        Zkoušce; v Produkci se ignoruje. Zbytek ochran platí dál (allowlist, hash šablony, canary,
        náhled příjemců). K přehodnocení před ostrým provozem.
      </p>
      <p>
        Stav: <strong>{on ? 'zapnuto' : 'vypnuto'}</strong>
        {state.data?.production ? ' (Produkce: nelze zapnout)' : ''}
      </p>
      {canChange && !state.data?.production ? (
        <div className="row">
          {on ? null : (
            <Field label="Potvrzení: napište SCHVALUJI SAM">
              <input value={text} onChange={(e) => setText(e.target.value)} />
            </Field>
          )}
          <button className="btn" onClick={() => change.mutate(!on)}>
            {on ? 'Vypnout' : 'Zapnout'}
          </button>
        </div>
      ) : null}
      {note ? <p className="hint">{note}</p> : null}
    </Panel>
  );
}
